"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoQuestionCollapseWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var InfoQuestionCollapseWrapper = /** @class */ (function (_super) {
    __extends(InfoQuestionCollapseWrapper, _super);
    function InfoQuestionCollapseWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var _a;
            return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(_this.props.className || "", " ").concat(_this.state.isInfoSectionOpen ? (_this.props.classNameOpened || "info-box inner-content negative-margin width-auto") : ""), children: [(0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-between align-items-start info-button-start", children: (0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)("span", { className: "whitespace-normal-span", children: _this.props.label }), "\u00A0", (0, jsx_runtime_1.jsx)("span", { className: "info-button-container", children: (0, jsx_runtime_1.jsx)("div", { tabIndex: 0, className: "info-button ml-2 ".concat(_this.state.isInfoSectionOpen ? "selected" : ""), "aria-label": "Info button for more information about NCD", onClick: _this.toggleInfoSection, onKeyPress: _this.toggleInfoSection }) }), (_a = _this.props.helperInfo) !== null && _a !== void 0 ? _a : ""] }) }), _this.state.isInfoSectionOpen && _this.renderInfoSection(), (0, jsx_runtime_1.jsx)("div", { className: "info-child-container", children: _this.props.children })] }));
        };
        _this.toggleInfoSection = function () {
            var _a, _b;
            var isInfoSectionOpen = !_this.state.isInfoSectionOpen;
            _this.setState(function () { return ({
                isInfoSectionOpen: isInfoSectionOpen
            }); });
            (_b = (_a = _this.props).onSectionOpenChange) === null || _b === void 0 ? void 0 : _b.call(_a, isInfoSectionOpen);
        };
        _this.renderInfoSection = function () {
            return (_this.props.info);
        };
        _this.state = {
            isInfoSectionOpen: false
        };
        return _this;
    }
    return InfoQuestionCollapseWrapper;
}(React.Component));
exports.InfoQuestionCollapseWrapper = InfoQuestionCollapseWrapper;
//# sourceMappingURL=InfoQuestionCollapseWrapper.js.map